import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

// 流量管理页面
import TrafficCardImport from './pages/traffic/TrafficCardImport';
import TrafficCardList from './pages/traffic/TrafficCardList';

// 设备管理页面
import DeviceType from './pages/device/DeviceType';
import DeviceBatch from './pages/device/DeviceBatch';
import DeviceImport from './pages/device/DeviceImport';
import DeviceList from './pages/device/DeviceList';

// 套餐管理页面
import PackageTemplate from './pages/package/PackageTemplate';
import PackageGroupList from './pages/package/PackagGroupList';
import PackageList from './pages/package/PackageList';

// 订单管理页面
import OrderList from './pages/order/OrderList';
import OrderStatistics from './pages/order/OrderStatistics';

// 其他页面
import MerchantManagement from './pages/MerchantManagement';
import FinanceManagement from './pages/FinanceManagement';

// 配置管理页面
import WxAppList from './pages/config/WxAppList';
import WxMerchantList from './pages/config/WxMerchantList';
import PaymentChannelConfig from './pages/config/PaymentChannelConfig';
import LegacyPaymentChannelConfig from './pages/config/LegacyPaymentChannelConfig';
import PaymentAppCredentialConfig from './pages/config/PaymentAppCredentialConfig';
import PaymentMerchantConfig from './pages/config/PaymentMerchantConfig';

// 经销商管理页面
import DealerList from './pages/dealer/DealerList';

// 用户管理页面
import UserList from './pages/user/UserList';
import RoleManagement from './pages/user/RoleManagement';

import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          {/* 公开路由 */}
          <Route path="/login" element={<Login />} />
          
          {/* 私有路由 */}
                           <Route path="/" element={
                   <PrivateRoute>
                     <MainLayout />
                   </PrivateRoute>
                 }>
                   <Route index element={<Navigate to="/dashboard" replace />} />
                   <Route path="dashboard" element={<Dashboard />} />
                   
                   {/* 流量管理 */}
                   <Route path="traffic/import" element={<TrafficCardImport />} />
                   <Route path="traffic/list" element={<TrafficCardList />} />
                   
                  {/* 设备管理 */}
                  <Route path="device/type" element={<DeviceType />} />
                  <Route path="device/batch" element={<DeviceBatch />} />
                  <Route path="device/import" element={<DeviceImport />} />
                  <Route path="device/list" element={<DeviceList />} />
                   
                  {/* 套餐管理 */}
                  <Route path="package/template" element={<PackageTemplate />} />
                  <Route path="package/group/list" element={<PackageGroupList />} />
                  <Route path="package/list" element={<PackageList />} />
                  
                  {/* 订单管理 */}
                  <Route path="order/list" element={<OrderList />} />
                  <Route path="order/statistics" element={<OrderStatistics />} />
                  
                  {/* 其他页面 */}
                  <Route path="merchant" element={<MerchantManagement />} />
                  <Route path="finance" element={<FinanceManagement />} />
                   
                   {/* 经销商管理 */}
                   <Route path="dealer/list" element={<DealerList />} />
                   
                   {/* 用户管理 */}
                   <Route path="user/list" element={<UserList />} />
                   <Route path="user/role" element={<RoleManagement />} />

                   {/* 配置管理 */}
                   <Route path="config/wx-app" element={<WxAppList />} />
                   <Route path="config/merchant" element={<WxMerchantList />} />
                   <Route path="config/payment-app-credential" element={<PaymentAppCredentialConfig />} />
                   <Route path="config/payment-merchant" element={<PaymentMerchantConfig />} />
                   <Route path="config/payment" element={<PaymentChannelConfig />} />
                   <Route path="config/payment-legacy" element={<LegacyPaymentChannelConfig />} />
                 </Route>
          
          {/* 默认重定向到登录页 */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
